import React from 'react';
import { Field } from 'redux-form';
import { required, SelectInput, TextInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

const ValidateRequired = required();

const styles = createStyles({
  valueInput: {
    width: '90%'
  },
  valueSelect: {
    width: '90%'
  },
  valueText: {
    paddingTop: 28
  }
});

type Props = {
  choices: any,
  classes: any,
  item: string
};

const PropertyValue = (props: Props) => (
  <div
    style={{ flex: '1' }}
    className={props.choices.length === 1 ? props.classes.valueText : null}
  >
    {props.choices.length > 1 && <Field
      choices={props.choices}
      className={props.classes.valueSelect}
      component={SelectInput}
      label="Value"
      name={`${props.item}.value`}
      source={`${props.item}.value`}
      validate={ValidateRequired} />}

    {props.choices.length === 1 && props.choices[0].name}

    {props.choices.length === 0 && <Field
      className={props.classes.valueInput}
      component={TextInput}
      label="Value"
      name={`${props.item}.value`}
      source={`${props.item}.value`}
      validate={ValidateRequired} />}
  </div>
);

export default withStyles(styles)(PropertyValue);



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Properties/PropertyValue.tsx